module.exports = __webpack_public_path__ + "static/media/hot_seller.b1361237.png";